export const reviewMarks = [
  {
    value: 20,
    label: 'Poor',
  },
  {
    value: 40,
    label: 'Average',
  },
  {
    value: 60,
    label: 'Good',
  },
  {
    value: 80,
    label: 'Very Good',
  },
  {
    value: 100,
    label: 'Excellent',
  },
];
